/**
 * The Ads Builder element card's two other animations, under the entrance's: the emphasis that plays
 * after it comes in and the exit that takes it away. See routes/playable-editor-properties-effect-slot.tsx.
 */
export const playableEffectSlots: Record<string, string> = {
  'playable.editor.emphasis.label': 'Animation nhấn mạnh',
  'playable.editor.emphasis.start': 'Bắt đầu lúc (giây)',
  'playable.editor.emphasis.beforeEntrance': 'Animation này đổi độ mờ, nên nếu chạy trước lúc animation vào kết thúc (giây thứ {s}) nó che mất phần cuối của animation vào.',
  'playable.editor.exit.label': 'Animation ra',
  'playable.editor.exit.start': 'Ẩn lúc (giây)',
  'playable.editor.exit.hintGroup': 'Chỉ khung của nhóm biến mất ở giây này, tính từ lúc màn hiện ra. Tích “Ẩn cả các phần tử trong nhóm” để các phần tử bên trong cũng biến mất.',
  'playable.editor.exit.cascade': 'Ẩn cả các phần tử trong nhóm',
  'playable.editor.exit.cascadeHint': 'Mọi phần tử trong nhóm cùng biến mất vào giây này, riêng nút chuyển màn thì vẫn hiện.',
  'playable.editor.exit.groupHoldsTrigger': 'Nhóm này có nút chuyển màn nên nút đó vẫn hiện, để người chơi còn chỗ bấm.',
  'playable.editor.exit.triggerWhy': 'Phần tử này là nút bấm để chuyển màn. Ẩn nó đi thì màn không còn gì để bấm, nên nó không có animation ra.',
  'playable.editor.exit.beforeEntrance': 'Ẩn lúc này sớm hơn lúc animation vào kết thúc (giây thứ {s}), nên phần tử chưa kịp hiện đủ đã ẩn đi.',
  'playable.editor.exit.tooLate': 'Màn này chuyển sau {s} giây nên phần tử chưa kịp ẩn.',
  'playable.editor.exit.preset.fade-out': 'Mờ dần rồi biến mất',
  'playable.editor.exit.preset.zoom-out': 'Thu nhỏ rồi biến mất',
  'playable.editor.exit.preset.slide-out-up': 'Trượt lên rồi biến mất',
  'playable.editor.exit.preset.slide-out-down': 'Trượt xuống rồi biến mất',
  'playable.editor.exit.preset.vanish': 'Biến mất ngay',
}
